module.exports = __webpack_public_path__ + "static/media/issue-inactive.5e12899c.svg";